<template>
  <vs-tabs>
    <vs-tab :label="$t('cti_functions')">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-checkbox v-model="userPermissionFormData.dial" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-dial"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('dial')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.blindtransfer" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-blind-transfer"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('blind_transfer')"></span>
          </vs-checkbox>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-checkbox v-model="userPermissionFormData.attendedtransfer" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-attended-transfer"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('attended_transfer')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.transfer" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-transfer"></i>
            </vs-button>

            <span class="ml-4" v-text="$tc('transfer')"></span>
          </vs-checkbox>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-checkbox v-model="userPermissionFormData.listen" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-listen"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('listen')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.whisper" class="mt-3 mb-3">
            <vs-button
              class="includeIcon includeIconOnly inline-block ml-4"
              color="success"
              type="border">
              <i class="c-icon-whisper"></i>
            </vs-button>

            <span class="ml-4" v-text="$t('whisper')"></span>
          </vs-checkbox>
        </div>
      </div>
    </vs-tab>

    <vs-tab :label="$t('menu_functions')">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-checkbox v-model="userPermissionFormData.dashboard_stat" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('dashboard_stat')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.menu_queue_status">
            <span class="ml-4" v-text="$t('menu_queue_status')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.manage_users" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_manage_users')">
            <span class="ml-4" v-text="$t('manage_users')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.configurations" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_configuration')">
            <span class="ml-4" v-text="$t('configuration')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.sms" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_manage_messages')">
            <span class="ml-4" v-text="$t('sms')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.dashboard" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_dashboard')">
            <span class="ml-4" v-text="$t('dashboard')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.members" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_members')">
            <span class="ml-4" v-text="$t('members')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.tasks" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_task')">
            <span class="ml-4" v-text="$t('tasks')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.message_management" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_message_management')">
            <span class="ml-4" v-text="$t('message_management')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.menu_schedules" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('menu_schedules')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.branch_extension" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_branch_extension')">
            <span class="ml-4" v-text="$t('branch_extension')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.extension_status_data_analysis" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_extension_status_data_analysis')">
            <span class="ml-4" v-text="$t('extension_status_data_analysis')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="userPermissionFormData.blacklist" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_blacklist')">
            <span class="ml-4" v-text="$t('blacklist')"></span>
          </vs-checkbox>
        </div>

        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-checkbox v-model="userPermissionFormData.fax" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_manage_fax')">
            <span class="ml-4" v-text="$t('fax')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.set_working_hours" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('set_working_hours')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.recording_manager" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_recording_manager')">
            <span class="ml-4" v-text="$t('recording_manager')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.agent_analytics" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('agent_analytics')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.inbound_details" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('inbound_details')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="userPermissionFormData.outbound_details" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('outbound_details')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="userPermissionFormData.inbound_statistics" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('inbound_statistics')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="userPermissionFormData.call_statistics" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('call_statistics')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.consultations" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_consultations')">
            <span class="ml-4" v-text="$tc('consultation', 2)"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.my_account" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_my_account')">
            <span class="ml-4" v-text="$t('my_account')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.projects" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_projects')">
            <span class="ml-4" v-text="$tc('project', 2)"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.slogan" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_use_slogan')">
            <span class="ml-4" v-text="$t('slogan')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="userPermissionFormData.upload_sound_file" class="mt-3 mb-3" v-if="$store.getters.hasCompanyPermission('company_can_upload_sound_file')">
            <span class="ml-4" v-text="$t('upload_sound_file')"></span>
          </vs-checkbox>
        </div>
      </div>
    </vs-tab>

    <vs-tab :label="$t('sub_functions')">
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-checkbox v-model="userPermissionFormData.call_list" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('call_list')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.call_back" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('call_back')"></span>
          </vs-checkbox>

          <vs-checkbox v-model="userPermissionFormData.cti_new_window" class="mt-3 mb-3">
            <span class="ml-4" v-text="$t('cti_new_window')"></span>
          </vs-checkbox>
        </div>
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import { EventBus } from '@/../eventbus'
import Users from '@/models/User'

export default {
  name: 'Shared.User.Permission.Edit',
  data () {
    return {
      userPermissionFormData: {},
      userPermissionFormErrors: {}
    }
  },
  mounted () {
    this.initUserPermissionFormData()
    EventBus.$on('loadUserPermission', this.loadUserPermission)
    EventBus.$on('initUpdateUserPermission', this.initUpdateUserPermission)
    EventBus.$on('initUserPermissionFormData', this.initUserPermissionFormData)
  },
  methods: {
    async loadUserPermission  (id) {
      try {
        const response = await Users.viewPermission({ id })
        this.userPermissionFormData = response.data.userPermission
        this.userPermissionFormData.id = id
        this.userPermissionFormErrors = {}
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    },
    async initUpdateUserPermission () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editUserPermissionButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          const response = await Users.updatePermission(this.userPermissionFormData)
          this.$store.dispatch('setIsFormInProgress', false)
          this.userPermissionFormErrors = {}
          this.$emit('updateUserPermissionSuccess', response)
        }
      } catch (e) {
        this.userPermissionFormErrors = e.response.data.errors
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#editUserPermissionButton > .con-vs-loading')
    },
    initUserPermissionFormData () {
      this.userPermissionFormData = {
        id: '',
        dial: false,
        blindtransfer: false,
        attendedtransfer: false,
        transfer: false,
        listen: false,
        whisper: false,
        dashboard_stat: false,
        menu_queue_status: false,
        manage_users: false,
        configurations: false,
        sms: false,
        fax: false,
        set_working_hours: false,
        recording_manager: false,
        agent_analytics: false,
        inbound_details: false,
        outbound_details: false,
        inbound_statistics: false,
        call_statistics: false,
        call_list: false,
        call_back: false,
        cti_new_window: false,
        dashboard: true,
        consultations: true,
        members: true,
        my_account: true,
        tasks: false,
        projects: false,
        message_managent: false
      }
      this.userPermissionFormErrors = {}
    }
  }
}
</script>

<style lang="scss">
  #editUserPermissionButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
